/**
 * ConnectionsRpcClient — AtomRpc integration for the customer-facing
 * connections surface (`connections/*`, CLA-429). Drives the onboarding Connect
 * stop: codex device-capture, per-provider OAuth start/callback, API-key save,
 * and the intake-vs-connected status projection — every call scoped to the
 * caller's OWN agent. Clerk session auth via the standard `AuthMiddleware` (NOT
 * admin), same plumbing as {@link OnboardingRpcClient}.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { ConnectionsRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class ConnectionsRpcClient extends AtomRpc.Tag<ConnectionsRpcClient>()(
  "ConnectionsRpcClient",
  {
    group: ConnectionsRpcs,
    protocol: makeRpcClientLayer(ConnectionsRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
